import React, { useState } from "react";
import "./Accommodation.css";

const accommodations = [
  {
    id: 1,
    name: "Nelpura Hall",
    subtitle: "Wooden Floor",
    bed: 250,
    mat: 200,
    capacity: 150,
    icon: "🏛️",
    desbed:"1 bed, 2 bed sheet, 1 pillow",
    desmat:"1 mat, 2 bed sheet, 1 pillow",
    // featured: true,
  },
  {
    id: 2,
    name: "Nelpura Front",
    subtitle: "Marble Floor Mugappu",
    bed: 250,
    mat: 200,
    capacity: 40,
    icon: "🏠",
    desbed:"1 bed, 2 bed sheet, 1 pillow",
    desmat:"1 mat, 2 bed sheet, 1 pillow",
  },
  {
    id: 3,
    name: "Old Store Room",
    subtitle: "Old Store Room",
    bed: 250,
    mat: 200,
    capacity: 10,
    icon: "🛏️",
    desbed:"1 bed, 2 bed sheet, 1 pillow",
    desmat:"1 mat, 2 bed sheet, 1 pillow",
  },
  {
    id: 4,
    name: "Upstairs Hall",
    subtitle: "Upstair Hall",
    bed: 250,
    mat: 200,
    capacity: 20,
    icon: "🏢",
    desbed:"1 bed, 2 bed sheet, 1 pillow",
    desmat:"1 mat, 2 bed sheet, 1 pillow",
  },
  {
    id: 5,
    name: "Front Hall",
    subtitle: "Front Hall",
    bed: 250,
    mat: 200,
    capacity: 50,
    icon: "🏛️",
    desbed:"1 bed, 2 bed sheet, 1 pillow",
    desmat:"1 mat, 2 bed sheet, 1 pillow",
  },
];

export default function Accommodation() {

  const [rateType, setRateType] = useState("bed");

  return (
    <section className="accommodation-section">

      {/* Decorative background */}
      <div className="accommodation-glow glow-one"></div>
      <div className="accommodation-glow glow-two"></div>


      <div className="accommodation-wrapper">

        {/* ======================================
            HEADER
        ====================================== */}

        {/* <div className="accommodation-header">

          <div className="header-label">
            <span>✦</span>
            DEVOTEE ACCOMMODATION
            <span>✦</span>
          </div>

          <h1>
            Stay with <span>Peace & Comfort</span>
          </h1>

          <p>
            Comfortable accommodation facilities are available for devotees
            visiting Sree Padmanabhaswamy Temple.
          </p>

          <div className="heading-decoration">
            <span></span>
            <i>✦</i>
            <span></span>
          </div>

        </div> */}


        {/* ======================================
            CONTACT BAR
        ====================================== */}

        <div className="contact-panel">

          <div className="contact-info">

            <div className="contact-icon">
              ☎
            </div>

            <div>
              <small>Accommodation Facilities available for Devotees</small>

              <strong>
                Contact Us
              </strong>
            </div>

          </div>


          <div className="contact-numbers">

            <a href="tel:+914712472086">
              +91 471 247 2086
            </a>

            <a href="tel:+919947122266">
              +91 99471 22266
            </a>

          </div>

        </div>


        {/* ======================================
            RATE SWITCH
        ====================================== */}

        <div className="rate-section">

          <div className="rate-heading">
            <span>Accommodation Facilities available for Devotees</span>

            <small>
              Per person / 24 hours
            </small>
          </div>


          <div className="rate-switch">

            <button
              className={rateType === "bed" ? "active" : ""}
              onClick={() => setRateType("bed")}
            >
              <span>🛏️</span>
              With Bed
            </button>

            <button
              className={rateType === "mat" ? "active" : ""}
              onClick={() => setRateType("mat")}
            >
              <span>▱</span>
              With Mat
            </button>

          </div>

        </div>


        {/* ======================================
            ACCOMMODATION CARDS
        ====================================== */}

        <div className="accommodation-grid">

          {accommodations.map((item) => (

            <div
              className={`stay-card ${
                item.featured ? "featured-stay" : ""
              }`}
              key={item.id}
            >

              {/* Card top */}

              <div className="stay-top">

                <div className="stay-number">
                  {String(item.id).padStart(2, "0")}
                </div>

                <div className="stay-icon">
                  {item.icon}
                </div>

              </div>


              {/* Name */}

              <div className="stay-title">

                <h2>
                  {item.name}
                </h2>

                <span>
                  {item.subtitle}
                </span>

              </div>


              {/* Price */}

              <div className="stay-price">

                <small>
                  {rateType === "bed"
                    ? "WITH BED"
                    : "WITH MAT"}
                </small>

                <div>

                  <strong>
                    ₹{rateType === "bed"
                      ? item.bed
                      : item.mat}
                  </strong>

                  <span>
                    / person
                  </span>

                </div>

                <p>
                  24 hours
                </p>

              </div>


              {/* Capacity */}

              <div className="capacity">

                <div className="capacity-heading">

                  <span>
                    Maximum Capacity
                  </span>

                  <strong>
                    {item.capacity}
                  </strong>

                </div>

                <div className="capacity-bar">

                  <span
                    style={{
                      width: `${Math.min(
                        (item.capacity / 150) * 100,
                        100
                      )}%`,
                    }}
                  ></span>

                </div>

                <small>
                  persons allowed
                </small>

              </div>


              {/* Footer */}

              <div className="stay-footer">

                <span>
                  ✓ {rateType === "bed"
                      ? item.desbed
                      : item.desmat}
                </span>


                <span className="arrow">
                  ↗ 
                </span>

              </div>

            </div>

          ))}

        </div>


        {/* ======================================
            INFORMATION
        ====================================== */}

        {/* <div className="accommodation-note">

          <div className="note-icon">
            ℹ
          </div>

          <div>

            <strong>
              Important Information
            </strong>

            <p>
              Accommodation is subject to availability. Devotees are
              requested to contact the accommodation office for current
              availability, booking procedures and further details.
            </p>

          </div>

        </div> */}

      </div>

    </section>
  );
}